/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/custom_attribute_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/custom_attribute_remote_lookup_provider.rb) */
export const filtersTypeSchema = z.strictObject({
  attribute_types: z
    .array(z.enum(["Array", "Boolean", "Nil", "Number", "Object", "Object Array", "String", "Time"]))
    .nullable()
    .optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/custom_attribute_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = z.object({
  attribute_types: z.array(
    z.enum(["Array", "Boolean", "Nil", "Number", "Object", "Object Array", "String", "Time"])
  ),
});
